import { DialogComponent } from '@theme/dialog';

/**
 * Size Guide modal — extends DialogComponent with lazy content injection and unit tabs.
 *
 * @typedef {object} Refs
 * @property {HTMLDialogElement} dialog
 * @property {HTMLElement} content
 * @property {HTMLTemplateElement} contentTemplate
 *
 * @extends {DialogComponent<Refs>}
 */
class SizeGuideDialog extends DialogComponent {
  #contentLoaded = false;
  #unitBound = false;

  showDialog() {
    if (!this.#contentLoaded) {
      const { contentTemplate, content } = this.refs;

      if (contentTemplate?.content && content) {
        content.appendChild(contentTemplate.content.cloneNode(true));
        this.#contentLoaded = true;
      }
    }

    this.#bindUnitToggle();
    super.showDialog();
  }

  #bindUnitToggle() {
    if (this.#unitBound) return;

    const { content } = this.refs;
    if (!content) return;

    const tabs = content.querySelectorAll('[data-size-guide-unit]');
    const panels = content.querySelectorAll('[data-size-guide-panel]');

    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const unit = tab.getAttribute('data-size-guide-unit');
        if (!unit) return;

        tabs.forEach((t) => {
          const isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const show = panel.getAttribute('data-size-guide-panel') === unit;
          panel.hidden = !show;
        });
      });
    });

    this.#unitBound = true;
  }
}

if (!customElements.get('size-guide-dialog')) {
  customElements.define('size-guide-dialog', SizeGuideDialog);
}
